"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../modules/wallet/selectors");
const selectors_2 = require("../../modules/profile/selectors");
const selectors_3 = require("../../modules/translation/selectors");
const actions_1 = require("../../modules/wallet/actions");
const Navbar2_1 = __importDefault(require("./Navbar2"));
const mapState = (state) => {
    const address = (0, selectors_1.getAddress)(state);
    const profile = address ? (0, selectors_2.getData)(state)[address] : undefined;
    return {
        avatar: profile ? profile.avatars[0] : undefined,
        chainId: (0, selectors_1.getChainId)(state),
        manaBalances: (0, selectors_1.getManaBalances)(state),
        address: (0, selectors_1.getAddress)(state),
        locale: (0, selectors_3.getLocale)(state),
        isSignedIn: (0, selectors_1.isConnected)(state),
        isSigningIn: (0, selectors_1.isConnecting)(state),
        appChainId: (0, selectors_1.getAppChainId)(state),
        isSwitchingNetwork: (0, selectors_1.isSwitchingNetwork)(state)
    };
};
const mapDispatch = (dispatch) => ({
    onSwitchNetwork: chainId => dispatch((0, actions_1.switchNetworkRequest)(chainId)),
    onSignOut: () => dispatch((0, actions_1.disconnectWallet)())
});
const mergeProps = (stateProps, dispatchProps, ownProps) => (Object.assign(Object.assign(Object.assign({}, stateProps), dispatchProps), ownProps));
exports.default = (0, react_redux_1.connect)(mapState, mapDispatch, mergeProps)(Navbar2_1.default);
//# sourceMappingURL=Navbar2.container.js.map